var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "select-text" },
    [
      _c(
        "div",
        {
          staticClass:
            "prospect-details-panel fixed w-screen top-18 flex justify-end transition-all duration-500",
          style: {
            right: _vm.open ? "0vw" : "-200vw",
            height: "calc(100vh - 4.5rem)",
            zIndex: 51
          },
          attrs: { id: "prospect-details-panel" }
        },
        [
          _c("div", {
            staticClass: "h-full w-screen absolute left-0 top-0 -z-10",
            on: {
              click: function($event) {
                return _vm.$emit("close-panel")
              }
            }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "h-full w-5 rounded-l-3xl flex-shrink-0 relative z-0",
            style: {
              background: "linear-gradient(180deg, #FFE4E8 0%, #9A8AC2 100%)"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "h-full w-120 flex-shrink-0 flex flex-col bg-pure-white relative z-0"
            },
            [
              !_vm.panelLoading && _vm.prospectStage
                ? _c(
                    "div",
                    { staticClass: "pt-4 pb-3 px-6 flex flex-col gap-1" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "relative flex items-center justify-between"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-2" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "select-move-prospect-stage rounded-full flex-shrink-0 min-h-6 px-3 flex items-center gap-1 transition-all duration-300 cursor-pointer",
                                  class: [
                                    _vm.prospectStage.is_discontinued
                                      ? "bg-rose-200"
                                      : _vm.prospectStage.is_admitted
                                      ? "bg-lime-200 pointer-events-none"
                                      : "bg-cornflower-200"
                                  ],
                                  on: {
                                    click: function($event) {
                                      _vm.stageOptionsOpened = !_vm.stageOptionsOpened
                                    }
                                  }
                                },
                                [
                                  _c("BlTextBody3", {
                                    staticClass: "current-stage-text",
                                    class: [
                                      _vm.stageOptionsOpened ? "flex" : "",
                                      _vm.prospectStage.is_discontinued
                                        ? "text-rose-700"
                                        : _vm.prospectStage.is_admitted
                                        ? "text-lime-700"
                                        : "text-cornflower-800"
                                    ],
                                    attrs: { text: "Current stage:" }
                                  }),
                                  _vm._v(" "),
                                  _vm.prospectStage.is_admitted
                                    ? _c("BlIcon", {
                                        staticClass: "w-4 h-4",
                                        attrs: {
                                          icon: "confetti",
                                          color: "lime-7"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("BlTextSubtitle3", {
                                    class: [
                                      _vm.prospectStage.is_discontinued
                                        ? "text-rose-700"
                                        : _vm.prospectStage.is_admitted
                                        ? "text-lime-700"
                                        : "text-cornflower-800"
                                    ],
                                    attrs: {
                                      text: _vm.prospectStage.stage.name
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.prospectStage.is_admitted
                                    ? _c("BlIcon", {
                                        staticClass: "w-4 h-4",
                                        attrs: {
                                          icon: "confetti",
                                          color: "lime-7"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.open && !_vm.prospectStage.is_admitted
                                    ? _c("BlIcon", {
                                        staticClass:
                                          "w-4 h-4 transition-all duration-300",
                                        style: {
                                          rotate: _vm.stageOptionsOpened
                                            ? "180deg"
                                            : ""
                                        },
                                        attrs: {
                                          icon: "chevron-down",
                                          color: _vm.prospectStage
                                            .is_discontinued
                                            ? "error"
                                            : "cornflower-8"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.moveProspectLoading
                                ? _c("div", { staticClass: "blum-loader-xs" })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _vm.stageOptionsOpened
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "absolute z-50 top-8 left-0 p-1 gap-1 flex flex-col min-w-40 bg-pure-white rounded border border-slate-400 truncate"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "px-4 py-2 flex text-left rounded max-w-80"
                                    },
                                    [
                                      _c("BlTextBody2", {
                                        staticClass: "text-slate-1000",
                                        attrs: { text: "Move to:" }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._l(_vm.stages, function(stage) {
                                    return _c(
                                      "div",
                                      {
                                        key: stage.id,
                                        staticClass:
                                          "px-2 py-1.5 flex rounded max-w-80",
                                        class: [
                                          stage.id ===
                                          _vm.prospectStage.stage.id
                                            ? "bg-slate-100 pointer-events-none"
                                            : "hover:bg-hover-state cursor-pointer"
                                        ],
                                        attrs: { title: stage.name },
                                        on: {
                                          click: function($event) {
                                            return _vm.openMoveProspect(
                                              stage.id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("BlChip", {
                                          attrs: { chip: stage.name }
                                        })
                                      ],
                                      1
                                    )
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.open
                            ? _c("BlIcon", {
                                staticClass: "h-6 w-6",
                                attrs: {
                                  icon: "close",
                                  color: "slate-6",
                                  clickable: ""
                                },
                                on: {
                                  clicked: function($event) {
                                    return _vm.$emit("close-panel")
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("BlTextTitle4", {
                        staticClass: "truncate",
                        attrs: {
                          text: _vm.prospectStage.prospect.name,
                          title: _vm.prospectStage.prospect.name
                        }
                      }),
                      _vm._v(" "),
                      _vm.prospectStage.is_discontinued
                        ? _c(
                            "span",
                            [
                              _vm.prospectStage.discontinuation_reason ===
                              "other"
                                ? _c("BlTextBody2", {
                                    attrs: {
                                      text:
                                        "Reason: " +
                                        _vm.prospectStage
                                          .other_discontinuation_reason
                                    }
                                  })
                                : _c("BlTextBody2", {
                                    attrs: {
                                      text:
                                        "Reason: " +
                                        _vm.prospectStage
                                          .discontinuation_reason_text
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.panelLoading
                ? _c(
                    "div",
                    { staticClass: "h-full grid items-center justify-center" },
                    [_c("div", { staticClass: "blum-loader" })]
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "relative h-full flex flex-col justify-between overflow-y-auto"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-col" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "h-10 w-full px-2 flex gap-2 overflow-x-auto overflow-y-hidden scrollbar-lg",
                              attrs: {
                                title:
                                  "'Shift key + scroll mouse' for horizontal scrolling"
                              }
                            },
                            _vm._l(_vm.tabs, function(tab) {
                              return _c(
                                "div",
                                {
                                  key: tab.value,
                                  staticClass:
                                    "relative pb-2 flex-shrink-0 cursor-pointer border-b border-slate-400",
                                  on: {
                                    click: function($event) {
                                      _vm.activeTab = tab.value
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "px-4" },
                                    [
                                      tab.value === _vm.activeTab
                                        ? _c("BlTextSubtitle2", {
                                            attrs: { text: tab.label }
                                          })
                                        : _c("BlTextBody1", {
                                            attrs: { text: tab.label }
                                          })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "absolute bottom-0 h-1 w-full rounded transition-all duration-300",
                                    class: [
                                      tab.value === _vm.activeTab
                                        ? "bg-light-purple"
                                        : "bg-pure-white"
                                    ]
                                  })
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _vm.activeTab === "stage-instruction" &&
                          _vm.prospectStage
                            ? _c("StageInstructionTab")
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.activeTab === "instruction-history" &&
                          _vm.prospectStage
                            ? _c("InstructionHistoryTab")
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.activeTab === "client-information" &&
                          _vm.prospectStage
                            ? _c("ClientInformationTab", {
                                on: {
                                  "after-commit": function($event) {
                                    return _vm.$emit("after-commit")
                                  }
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.activeTab === "activity-history" &&
                          _vm.prospectStage
                            ? _c("ActivityHistoryTab")
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  ),
              _vm._v(" "),
              !_vm.panelLoading &&
              _vm.open &&
              _vm.prospectStage &&
              _vm.id === _vm.prospectStage.id
                ? _c("NewInstructionProspectPanel")
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      !_vm.panelLoading &&
      _vm.open &&
      _vm.prospectStage &&
      _vm.id === _vm.prospectStage.id &&
      _vm.moveProspectOpened
        ? _c("MoveProspectModal", {
            attrs: {
              location: _vm.location,
              prospectStage: _vm.prospectStage,
              destinationStage: _vm.destinationStage
            },
            on: {
              "close-modal": function($event) {
                _vm.moveProspectOpened = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24734db5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24734db5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/modal/ProspectPanel.vue
// module id = null
// module chunks = 